import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AffichageCGUService } from '../affichage-cgu/services/affichage-cgu.service';
import { CustomCookieService } from '../../services/custom-cookie.service';
import { AuthentificationService } from '../../services/auth/authentification.service';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.css'],
})
export class CookieConsentComponent implements OnInit {
  displayDialog = false;

  constructor(
    private cookieService: CustomCookieService,
    private router: Router,
    private readonly affichageCGUService: AffichageCGUService ,
    private authService : AuthentificationService

  ) {}

  ngOnInit(): void {
    this.getDocs();
  }

  acceptCookies(): void {
    this.cookieService.grantConsent();
    this.displayDialog = false;
  }

  denyCookies(): void {
    this.cookieService.denyConsent();
    this.displayDialog = false;

    this.router.navigate(['/cookie-error']);
  }

  downloadDocument(): void {
    this.affichageCGUService.getPdf('COOKIES').subscribe((blob: Blob): void => {
      // @ts-ignore
      const file = new Blob([blob], {type: 'application/pdf'});
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    });
  }

  getDocs() {
    let type = this.authService.getStoredAccess().type;
    if (type ==='ADMIN') return ;
    this.affichageCGUService.getDocumentsRgpdByCompanySite().subscribe(res => {
      const cookiesUpdateDate = res.find(doc => doc.typeDocument === "COOKIES")?.updateDate;
      this.displayDialog = !this.cookieService.isConsentUpToDate(cookiesUpdateDate);
    });
}
}
